<script setup lang="ts">
import RegisterInput from "@/register/views/RegisterInput.vue";
import {sponsorshipApi} from "@/container";
import {ref} from "vue";
import {DotLottieVue} from "@lottiefiles/dotlottie-vue";

const model = defineModel<string>();
const error = defineModel<string | undefined>("error");
const referral = ref<{ name: string; description: string | null } | undefined>();
const loading = ref(false);

const verifySponsor = async () => {
    if (model.value?.length) {
        try {
            loading.value = true;
            const response = await sponsorshipApi().check(model.value);

            if (!response.success) {
                error.value = 'Le code de parrainage n\'est lié à aucune organisation';
            } else {
                referral.value = response.sponsor;
                error.value = undefined;
            }
        } catch {
            error.value = 'Le code de parrainage n\'est pas valide, respectez bien les majuscules et minuscules du code';
        } finally {
            loading.value = false;
        }
    } else {
        referral.value = undefined;
        error.value = undefined;
    }
};
</script>

<template>
  <div class="space-y-2">
    <div class="flex w-full items-end gap-2">
      <RegisterInput
        v-model="model"
        class="flex-1"
        :error="error"
        type="text"
        placeholder="Code de parrainage"
        @blur="verifySponsor"
      />
      <div v-if="referral" class="ml-2">
        <p class="text-secondary">
          ✅ Code valide
        </p>
      </div>
    </div>
    <div v-if="referral?.description" class="bg-white rounded-md pl-2 text-sm flex items-center">
      <p>{{ referral.description }}</p>
      <div>
        <DotLottieVue
          src="animations/gift.lottie"
          autoplay loop
          class="w-16 h-16"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
